import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as apiSvcCntr from 'apiSaga/apiServiceCntr';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// 0. Response 초기화
const INIT_SERVICE_CNTR_RESP = 'svcCntr/INIT_SERVICE_CNTR_RESP';
const INIT_SYS_CODE_LIST_RESP = 'svcCntr/INIT_SYS_CODE_LIST_RESP';
const INIT_NOTICE_CLIENT_LIST_RESP = 'svcCntr/INIT_NOTICE_CLIENT_LIST_RESP';
const INIT_NOTICE_CLIENT_DETAIL_VIEW_RESP = 'svcCntr/INIT_NOTICE_CLIENT_DETAIL_VIEW_RESP';
const INIT_FAQ_CLIENT_LIST_RESP = 'svcCntr/INIT_FAQ_CLIENT_LIST_RESP';
const INIT_ARCHIVE_CLIENT_RESP = 'svcCntr/INIT_ARCHIVE_CLIENT_RESP';
const INIT_CLIENT_INQUIRY_LIST_RESP = 'svcCntr/INIT_CLIENT_INQUIRY_LIST_RESP';
const INIT_CLIENT_INQUIRY_DETAIL_VIEW_RESP = 'svcCntr/INIT_CLIENT_INQUIRY_DETAIL_VIEW_RESP';
const INIT_INSERT_QUESTION_RESP = 'svcCntr/INIT_INSERT_QUESTION_RESP';
const INIT_CHANGE_QUESTION_RESP = 'svcCntr/INIT_CHANGE_QUESTION_RESP';
const INIT_ARCHIVEFILE_DOWNLOAD_RESP = 'svcCntr/INIT_ARCHIVEFILE_DOWNLOAD_RESP';
const INIT_DELETE_INQRY_TOTAL_DATA_RESP = 'svcCntr/INIT_INSERT_REQST_CONSULT_RESP';
const INIT_ALL_NOTICE_POPUP_LOGIN_LIST_RESP = 'svcCntr/INIT_ALL_NOTICE_POPUP_LOGIN_LIST_RESP';
const INIT_EXCELL_NOTICE_CLIENT_LIST = 'svcCntr/INIT_EXCELL_NOTICE_CLIENT_LIST';
const INIT_EXCELL_CLIENT_INQUIRY_LIST = 'svcCntr/INIT_EXCELL_CLIENT_INQUIRY_LIST';
const INIT_NOTICE_FILE_DOWN_RESP = 'svcCntr/INIT_NOTICE_FILE_DOWN_RESP';
const INIT_NOTICE_DASHBOARD_RESP = 'svcCntr/INIT_NOTICE_DASHBOARD_RESP';
const INIT_ARCV_GET_CODE_LIST_RESP = 'svcCntr/INIT_ARCV_GET_CODE_LIST_RESP';
const INIT_GET_FAQ_TYPE_LIST_RESP = 'svcCntr/INIT_GET_FAQ_TYPE_LIST_RESP';

// U031. 상담 신청 페이지 업무 타입 코드 조회
const GET_SYS_CODE_LIST = 'svcCntr/GET_SYS_CODE_LIST';
const GET_SYS_CODE_LIST_SUCCESS = 'svcCntr/GET_SYS_CODE_LIST_SUCCESS';
const GET_SYS_CODE_LIST_FAILURE = 'svcCntr/GET_SYS_CODE_LIST_FAILURE';
// U033. 공지사항 목록 조회
const GET_NOTICE_CLIENT_LIST = 'svcCntr/GET_NOTICE_CLIENT_LIST';
const GET_NOTICE_CLIENT_LIST_SUCCESS = 'svcCntr/GET_NOTICE_CLIENT_LIST_SUCCESS';
const GET_NOTICE_CLIENT_LIST_FAILURE = 'svcCntr/GET_NOTICE_CLIENT_LIST_FAILURE';
// U034. 공지사항 목록 상세 조회
const GET_NOTICE_CLIENT_DETAIL_VIEW = 'svcCntr/GET_NOTICE_CLIENT_DETAIL_VIEW';
const GET_NOTICE_CLIENT_DETAIL_VIEW_SUCCESS = 'svcCntr/GET_NOTICE_CLIENT_DETAIL_VIEW_SUCCESS';
const GET_NOTICE_CLIENT_DETAIL_VIEW_FAILURE = 'svcCntr/GET_NOTICE_CLIENT_DETAIL_VIEW_FAILURE';
// U035. FAQ 목록
const GET_FAQ_CLIENT_LIST = 'svcCntr/GET_FAQ_CLIENT_LIST';
const GET_FAQ_CLIENT_LIST_SUCCESS = 'svcCntr/GET_FAQ_CLIENT_LIST_SUCCESS';
const GET_FAQ_CLIENT_LIST_FAILURE = 'svcCntr/GET_FAQ_CLIENT_LIST_FAILURE';
// U036. 자료실 목록
const GET_ARCHIVE_CLIENT = 'svcCntr/GET_ARCHIVE_CLIENT';
const GET_ARCHIVE_CLIENT_SUCCESS = 'svcCntr/GET_ARCHIVE_CLIENT_SUCCESS';
const GET_ARCHIVE_CLIENT_FAILURE = 'svcCntr/GET_ARCHIVE_CLIENT_FAILURE';
// U037. 문의 목록
const GET_CLIENT_INQUIRY_LIST = 'svcCntr/GET_CLIENT_INQUIRY_LIST';
const GET_CLIENT_INQUIRY_LIST_SUCCESS = 'svcCntr/GET_CLIENT_INQUIRY_LIST_SUCCESS';
const GET_CLIENT_INQUIRY_LIST_FAILURE = 'svcCntr/GET_CLIENT_INQUIRY_LIST_FAILURE';
// U038. 문의 상세보기
const GET_CLIENT_INQUIRY_DETAIL_VIEW = 'svcCntr/GET_CLIENT_INQUIRY_DETAIL_VIEW';
const GET_CLIENT_INQUIRY_DETAIL_VIEW_SUCCESS = 'svcCntr/GET_CLIENT_INQUIRY_DETAIL_VIEW_SUCCESS';
const GET_CLIENT_INQUIRY_DETAIL_VIEW_FAILURE = 'svcCntr/GET_CLIENT_INQUIRY_DETAIL_VIEW_FAILURE';
// U039. 문의 등록
const INSERT_QUESTION = 'svcCntr/INSERT_QUESTION';
const INSERT_QUESTION_SUCCESS = 'svcCntr/INSERT_QUESTION_SUCCESS';
const INSERT_QUESTION_FAILURE = 'svcCntr/INSERT_QUESTION_FAILURE';
// U040. 문의 수정
const CHANGE_QUESTION = 'svcCntr/CHANGE_QUESTION';
const CHANGE_QUESTION_SUCCESS = 'svcCntr/CHANGE_QUESTION_SUCCESS';
const CHANGE_QUESTION_FAILURE = 'svcCntr/CHANGE_QUESTION_FAILURE';
// U041. 자료실 유저 다운로드
const ARCHIVEFILE_DOWNLOAD = 'svcCntr/ARCHIVEFILE_DOWNLOAD';
const ARCHIVEFILE_DOWNLOAD_SUCCESS = 'svcCntr/ARCHIVEFILE_DOWNLOAD_SUCCESS';
const ARCHIVEFILE_DOWNLOAD_FAILURE = 'svcCntr/ARCHIVEFILE_DOWNLOAD_FAILURE';
// U042. 유저 문의 삭제
const DELETE_INQRY_TOTAL_DATA = 'svcCntr/DELETE_INQRY_TOTAL_DATA';
const DELETE_INQRY_TOTAL_DATA_SUCCESS = 'svcCntr/DELETE_INQRY_TOTAL_DATA_SUCCESS';
const DELETE_INQRY_TOTAL_DATA_FAILURE = 'svcCntr/DELETE_INQRY_TOTAL_DATA_FAILURE';

/*
// U043. 상담 신청 등록
const INERT_REQST_CONSULT = 'svcCntr/INERT_REQST_CONSULT';
const INERT_REQST_CONSULT_SUCCESS = 'svcCntr/INERT_REQST_CONSULT_SUCCESS';
const INERT_REQST_CONSULT_FAILURE = 'svcCntr/INERT_REQST_CONSULT_FAILURE';
*/

// U044. 로그인후 공지사항 팝업 뷰 리스트
const GET_ALL_NOTICE_POPUP_LOGIN_LIST = 'svcCntr/GET_ALL_NOTICE_POPUP_LOGIN_LIST';
const GET_ALL_NOTICE_POPUP_LOGIN_LIST_SUCCESS = 'svcCntr/GET_ALL_NOTICE_POPUP_LOGIN_LIST_SUCCESS';
const GET_ALL_NOTICE_POPUP_LOGIN_LIST_FAILURE = 'svcCntr/GET_ALL_NOTICE_POPUP_LOGIN_LIST_FAILURE';
// U047. 문의 게시판 엑셀 데이터 다운로드
const EXCELL_CLIENT_INQUIRY_LIST = 'svcCntr/EXCELL_CLIENT_INQUIRY_LIST';
const EXCELL_CLIENT_INQUIRY_LIST_SUCCESS = 'svcCntr/EXCELL_CLIENT_INQUIRY_LIST_SUCCESS';
const EXCELL_CLIENT_INQUIRY_LIST_FAILURE = 'svcCntr/EXCELL_CLIENT_INQUIRY_LIST_FAILURE';
//U048. 공지사항 게시판 엑셀 데이터 다운로드
const EXCELL_NOTICE_CLIENT_LIST = 'svcCntr/EXCELL_NOTICE_CLIENT_LIST';
const EXCELL_NOTICE_CLIENT_LIST_SUCCESS = 'svcCntr/EXCELL_NOTICE_CLIENT_LIST_SUCCESS';
const EXCELL_NOTICE_CLIENT_LIST_FAILURE = 'svcCntr/EXCELL_NOTICE_CLIENT_LIST_FAILURE';
//U067. 공지사항 게시판 파일 다운로드
const NOTICE_FILE_DOWN = 'svcCntr/NOTICE_FILE_DOWN';
const NOTICE_FILE_DOWN_SUCCESS = 'svcCntr/NOTICE_FILE_DOWN_SUCCESS';
const NOTICE_FILE_DOWN_FAILURE = 'svcCntr/NOTICE_FILE_DOWN_FAILURE';
//U1114. 대시보드 공지 [전체/MY]
const GET_NOTICE_DASHBOARD = 'svcCntr/GET_NOTICE_DASHBOARD';
const GET_NOTICE_DASHBOARD_SUCCESS = 'svcCntr/GET_NOTICE_DASHBOARD_SUCCESS';
const GET_NOTICE_DASHBOARD_FAILURE = 'svcCntr/GET_NOTICE_DASHBOARD_FAILURE';
// 자료실 드롭다운 리스트
const GET_ARCV_CODE_LIST = 'svcCntr/GET_ARCV_CODE_LIST';
const GET_ARCV_CODE_LIST_SUCCESS = 'svcCntr/GET_ARCV_CODE_LIST_SUCCESS';
const GET_ARCV_CODE_LIST_FAILURE = 'svcCntr/GET_ARCV_CODE_LIST_FAILURE';
// FAQ 드롭다운 리스트
const GET_FAQ_TYPE_LIST = 'svcCntr/GET_FAQ_TYPE_LIST';
const GET_FAQ_TYPE_LIST_SUCCESS = 'svcCntr/GET_FAQ_TYPE_LIST_SUCCESS';
const GET_FAQ_TYPE_LIST_FAILURE = 'svcCntr/GET_FAQ_TYPE_LIST_FAILURE';

// 0. Response 초기화
export const initServiceCntrResp = createAction(INIT_SERVICE_CNTR_RESP);
export const initSysCodeListResp = createAction(INIT_SYS_CODE_LIST_RESP);
export const initNoticeClientListResp = createAction(INIT_NOTICE_CLIENT_LIST_RESP);
export const initNoticeClientDeailViewResp = createAction(INIT_NOTICE_CLIENT_DETAIL_VIEW_RESP);
export const initFaqClientListResp = createAction(INIT_FAQ_CLIENT_LIST_RESP);
export const initArchiveClientResp = createAction(INIT_ARCHIVE_CLIENT_RESP);
export const initClientInquiryListResp = createAction(INIT_CLIENT_INQUIRY_LIST_RESP);
export const initClientInquiryDetailViewResp = createAction(INIT_CLIENT_INQUIRY_DETAIL_VIEW_RESP);
export const initInsertQuestiontResp = createAction(INIT_INSERT_QUESTION_RESP);
export const initChangeQuestionResp = createAction(INIT_CHANGE_QUESTION_RESP);
export const initArchivefileDownloadResp = createAction(INIT_ARCHIVEFILE_DOWNLOAD_RESP);
export const initDeleteInqryTotalDataResp = createAction(INIT_DELETE_INQRY_TOTAL_DATA_RESP);
export const initAllNoticePopupLoginListResp = createAction(INIT_ALL_NOTICE_POPUP_LOGIN_LIST_RESP);
export const initExcellNoticeClientListResp = createAction(INIT_EXCELL_NOTICE_CLIENT_LIST);
export const initExcellClientInquiryListResp = createAction(INIT_EXCELL_CLIENT_INQUIRY_LIST);
export const initNoticeFileDownResp = createAction(INIT_NOTICE_FILE_DOWN_RESP);
export const initNoticeDashBoardResp = createAction(INIT_NOTICE_DASHBOARD_RESP);
export const initArcvGetCodeListResp = createAction(INIT_ARCV_GET_CODE_LIST_RESP);
export const initGetFaqTypeListResp = createAction(INIT_GET_FAQ_TYPE_LIST_RESP);

// export const initNoticeFileDown
// 자료실 드롭다운 리스트
export const getArcvCodeList = createAction(GET_ARCV_CODE_LIST);
// U031. 상담 신청 페이지 업무 타입 코드 조회
export const getSysCodeList = createAction(GET_SYS_CODE_LIST, (sysGroupCode) => sysGroupCode);
// U033. 공지사항 목록 조회
export const getNoticeClientList = createAction(GET_NOTICE_CLIENT_LIST, (reqParam) => reqParam);
// U034. 공지사항 목록 상세 조회
export const getNoticeClientDetailView = createAction(GET_NOTICE_CLIENT_DETAIL_VIEW, (noticeSeq) => noticeSeq);

// U035. FAQ 목록
export const getFaqClientList = createAction(GET_FAQ_CLIENT_LIST, (reqParam) => reqParam);
// U036. 자료실 목록
export const getArchiveClient = createAction(GET_ARCHIVE_CLIENT, (reqParam) => reqParam);
// U037. 문의 목록
export const getClientInquiryList = createAction(GET_CLIENT_INQUIRY_LIST, (reqParam) => reqParam);
// U038. 문의 상세보기
export const getClientInquiryDetailView = createAction(GET_CLIENT_INQUIRY_DETAIL_VIEW, (inqrySeq) => inqrySeq);
// U039. 문의 등록
export const insertQuestion = createAction(INSERT_QUESTION, (dataParam) => dataParam);
// U040. 문의 수정
export const changeQuestion = createAction(CHANGE_QUESTION, (dataParam) => dataParam);
// U041. 자료실 유저 다운로드
export const ArchivefileDownload = createAction(ARCHIVEFILE_DOWNLOAD, (archvSeq) => archvSeq);
// U042. 유저 문의 삭제
export const deleteInqryTotalData = createAction(DELETE_INQRY_TOTAL_DATA, (dataParam) => dataParam);
// U044. 로그인후 공지사항 팝업 뷰 리스트
export const getAllNoticePopupLoginList = createAction(GET_ALL_NOTICE_POPUP_LOGIN_LIST, (usCode) => usCode);
// U047. 문의 게시판 엑셀 데이터 다운로드
export const excellClientInquiryList = createAction(EXCELL_CLIENT_INQUIRY_LIST, (reqParam) => reqParam);
// U048. 공지사항 게시판 엑셀 데이터 다운로드
export const excellNoticeClientList = createAction(EXCELL_NOTICE_CLIENT_LIST, (reqParam) => reqParam);
// U067. 공지사항 게시판 파일 다운로드
export const noticeFileDown = createAction(NOTICE_FILE_DOWN, (reqParam) => reqParam);
// U1114. 대시보드 공지 [전체/MY]
export const getNoticeDashBoard = createAction(GET_NOTICE_DASHBOARD, (reqParam) => reqParam);
// FAQ 드롭다운 리스트
export const getFaqTypeList = createAction(GET_FAQ_TYPE_LIST);

const getSysCodeListSaga = createRequestSaga(GET_SYS_CODE_LIST, apiSvcCntr.getSysCodeList);
const getNoticeClientListSaga = createRequestSaga(GET_NOTICE_CLIENT_LIST, apiSvcCntr.getNoticeClientList);
const getNoticeClientDetailViewSaga = createRequestSaga(
  GET_NOTICE_CLIENT_DETAIL_VIEW,
  apiSvcCntr.getNoticeClientDetailView
);
const getFaqClientListSaga = createRequestSaga(GET_FAQ_CLIENT_LIST, apiSvcCntr.getFaqClientList);
const getArchiveClientSaga = createRequestSaga(GET_ARCHIVE_CLIENT, apiSvcCntr.getArchiveClient);
const getClientInquiryListSaga = createRequestSaga(GET_CLIENT_INQUIRY_LIST, apiSvcCntr.getClientInquiryList);
const getClientInquiryDetailViewSaga = createRequestSaga(
  GET_CLIENT_INQUIRY_DETAIL_VIEW,
  apiSvcCntr.getClientInquiryDetailView
);
const insertQuestionSaga = createRequestSaga(INSERT_QUESTION, apiSvcCntr.insertQuestion);
const changeQuestionSaga = createRequestSaga(CHANGE_QUESTION, apiSvcCntr.changeQuestion);
const ArchivefileDownloadSaga = createRequestSaga(ARCHIVEFILE_DOWNLOAD, apiSvcCntr.ArchivefileDownload);
const deleteInqryTotalDataSaga = createRequestSaga(DELETE_INQRY_TOTAL_DATA, apiSvcCntr.deleteInqryTotalData);
const getAllNoticePopupLoginListSaga = createRequestSaga(
  GET_ALL_NOTICE_POPUP_LOGIN_LIST,
  apiSvcCntr.getAllNoticePopupLoginList
);
const excellNoticeClientListSaga = createRequestSaga(EXCELL_NOTICE_CLIENT_LIST, apiSvcCntr.excellNoticeClientList);
const excellClientInquiryListSaga = createRequestSaga(EXCELL_CLIENT_INQUIRY_LIST, apiSvcCntr.excellClientInquiryList);
const noticeFileDownSaga = createRequestSaga(NOTICE_FILE_DOWN, apiSvcCntr.noticeFileDown);
const getNoticeDashBoardSaga = createRequestSaga(GET_NOTICE_DASHBOARD, apiSvcCntr.getNoticeDashBoard);
const getArcvCodeListSaga = createRequestSaga(GET_ARCV_CODE_LIST, apiSvcCntr.getArcvCodeList);
const getFaqTypeListSaga = createRequestSaga(GET_FAQ_TYPE_LIST, apiSvcCntr.getFaqTypeList);

// apiSystemSaga
export function* apiServiceCntrSaga() {
  yield takeLatest(GET_SYS_CODE_LIST, getSysCodeListSaga);
  yield takeLatest(GET_NOTICE_CLIENT_LIST, getNoticeClientListSaga);
  yield takeLatest(GET_NOTICE_CLIENT_DETAIL_VIEW, getNoticeClientDetailViewSaga);
  yield takeLatest(GET_FAQ_CLIENT_LIST, getFaqClientListSaga);
  yield takeLatest(GET_ARCHIVE_CLIENT, getArchiveClientSaga);
  yield takeLatest(GET_CLIENT_INQUIRY_LIST, getClientInquiryListSaga);
  yield takeLatest(GET_CLIENT_INQUIRY_DETAIL_VIEW, getClientInquiryDetailViewSaga);
  yield takeLatest(INSERT_QUESTION, insertQuestionSaga);
  yield takeLatest(CHANGE_QUESTION, changeQuestionSaga);
  yield takeLatest(ARCHIVEFILE_DOWNLOAD, ArchivefileDownloadSaga);
  yield takeLatest(DELETE_INQRY_TOTAL_DATA, deleteInqryTotalDataSaga);
  yield takeLatest(GET_ALL_NOTICE_POPUP_LOGIN_LIST, getAllNoticePopupLoginListSaga);
  yield takeLatest(EXCELL_NOTICE_CLIENT_LIST, excellNoticeClientListSaga);
  yield takeLatest(EXCELL_CLIENT_INQUIRY_LIST, excellClientInquiryListSaga);
  yield takeLatest(NOTICE_FILE_DOWN, noticeFileDownSaga);
  yield takeLatest(GET_NOTICE_DASHBOARD, getNoticeDashBoardSaga);
  yield takeLatest(GET_ARCV_CODE_LIST, getArcvCodeListSaga);
  yield takeLatest(GET_FAQ_TYPE_LIST, getFaqTypeListSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getArcvCodeListResp: null,
  getSysCodeListResp: null,
  getNoticeClientListResp: null,
  getNoticeClientDetailViewResp: null,
  getFaqClientListResp: null,
  getArchiveClientResp: null,
  getClientInquiryListResp: null,
  getClientInquiryDetailViewResp: null,
  insertQuestionResp: null,
  changeQuestionResp: null,
  archivefileDownloadResp: null,
  deleteInqryTotalDataResp: null,
  getAllNoticePopupLoginListResp: null,
  excellNoticeClientListResp: null,
  excellClientInquiryListResp: null,
  noticeFileDownResp: null,
  getNoticeDashBoardResp: null,
  getFaqTypeListResp: null,
};

const apiServiceCntrResp = handleActions(
  {
    // 0. Response 초기화
    [INIT_SERVICE_CNTR_RESP]: (state, action) => ({
      getSysCodeListResp: null,
      getNoticeClientListResp: null,
      getNoticeClientDetailViewResp: null,
      getFaqClientListResp: null,
      getArchiveClientResp: null,
      getClientInquiryListResp: null,
      getClientInquiryDetailViewResp: null,
      insertQuestionResp: null,
      changeQuestionResp: null,
      archivefileDownloadResp: null,
      deleteInqryTotalDataResp: null,
      getAllNoticePopupLoginListResp: null,
      excellNoticeClientListResp: null,
      excellClientInquiryListResp: null,
      noticeFileDownResp: null,
      getNoticeDashBoardResp: null,
      getArcvCodeListResp: null,
      getFaqTypeListResp: null,
    }),
    [INIT_GET_FAQ_TYPE_LIST_RESP]: (state, action) => ({
      ...state,
      getFaqTypeListResp: null,
    }),
    [INIT_ARCV_GET_CODE_LIST_RESP]: (state, action) => ({
      ...state,
      getArcvCodeListResp: null,
    }),
    [INIT_SYS_CODE_LIST_RESP]: (state, action) => ({
      getSysCodeListResp: null,
    }),
    [INIT_NOTICE_CLIENT_LIST_RESP]: (state, action) => ({
      ...state,
      getNoticeClientListResp: null,
    }),
    [INIT_NOTICE_CLIENT_DETAIL_VIEW_RESP]: (state, action) => ({
      ...state,
      getNoticeClientDetailViewResp: null,
    }),
    [INIT_FAQ_CLIENT_LIST_RESP]: (state, action) => ({
      ...state,
      getFaqClientListResp: null,
    }),
    [INIT_ARCHIVE_CLIENT_RESP]: (state, action) => ({
      getArchiveClientResp: null,
    }),
    [INIT_CLIENT_INQUIRY_LIST_RESP]: (state, action) => ({
      ...state,
      getClientInquiryListResp: null,
    }),
    [INIT_CLIENT_INQUIRY_DETAIL_VIEW_RESP]: (state, action) => ({
      ...state,
      getClientInquiryDetailViewResp: null,
    }),
    [INIT_INSERT_QUESTION_RESP]: (state, action) => ({
      ...state,
      insertQuestionResp: null,
    }),
    [INIT_CHANGE_QUESTION_RESP]: (state, action) => ({
      changeQuestionResp: null,
    }),
    [INIT_ARCHIVEFILE_DOWNLOAD_RESP]: (state, action) => ({
      ...state,
      archivefileDownloadResp: null,
    }),
    [INIT_DELETE_INQRY_TOTAL_DATA_RESP]: (state, action) => ({
      ...state,
      deleteInqryTotalDataResp: null,
    }),
    [INIT_ALL_NOTICE_POPUP_LOGIN_LIST_RESP]: (state, action) => ({
      getAllNoticePopupLoginListResp: null,
    }),
    [INIT_EXCELL_NOTICE_CLIENT_LIST]: (state, action) => ({
      ...state,
      excellNoticeClientListResp: null,
    }),
    [INIT_EXCELL_CLIENT_INQUIRY_LIST]: (state, action) => ({
      ...state,
      excellClientInquiryListResp: null,
    }),
    [INIT_NOTICE_FILE_DOWN_RESP]: (state, action) => ({
      ...state,
      noticeFileDownResp: null,
    }),
    [INIT_NOTICE_DASHBOARD_RESP]: (state, action) => ({
      ...state,
      getNoticeDashBoardResp: null,
    }),
    // U031. 상담 신청 페이지 업무 타입 코드 조회
    [GET_SYS_CODE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getSysCodeListResp: action.payload,
    }),
    [GET_SYS_CODE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getSysCodeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 자료실 드롭다운 리스트
    [GET_ARCV_CODE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getArcvCodeListResp: action.payload,
    }),
    [GET_ARCV_CODE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getArcvCodeListResp: {
        result_code: 'E999',
        getArcvCodeListResp: action.payload,
      },
    }),
    // U033. 공지사항 목록 조회
    [GET_NOTICE_CLIENT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getNoticeClientListResp: action.payload,
    }),
    [GET_NOTICE_CLIENT_LIST_FAILURE]: (state, action) => ({
      ...state,
      getNoticeClientListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U034. 공지사항 목록 상세 조회
    [GET_NOTICE_CLIENT_DETAIL_VIEW_SUCCESS]: (state, action) => ({
      ...state,
      getNoticeClientDetailViewResp: action.payload,
    }),
    [GET_NOTICE_CLIENT_DETAIL_VIEW_FAILURE]: (state, action) => ({
      ...state,
      getNoticeClientDetailViewResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U035. FAQ 목록
    [GET_FAQ_CLIENT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getFaqClientListResp: action.payload,
    }),
    [GET_FAQ_CLIENT_LIST_FAILURE]: (state, action) => ({
      ...state,
      getFaqClientListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U036. 자료실 목록
    [GET_ARCHIVE_CLIENT_SUCCESS]: (state, action) => ({
      ...state,
      getArchiveClientResp: action.payload,
    }),
    [GET_ARCHIVE_CLIENT_FAILURE]: (state, action) => ({
      ...state,
      getArchiveClientResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U037. 문의 목록
    [GET_CLIENT_INQUIRY_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getClientInquiryListResp: action.payload,
    }),
    [GET_CLIENT_INQUIRY_LIST_FAILURE]: (state, action) => ({
      ...state,
      getClientInquiryListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U038. 문의 상세보기
    [GET_CLIENT_INQUIRY_DETAIL_VIEW_SUCCESS]: (state, action) => ({
      ...state,
      getClientInquiryDetailViewResp: action.payload,
    }),
    [GET_CLIENT_INQUIRY_DETAIL_VIEW_FAILURE]: (state, action) => ({
      ...state,
      getClientInquiryDetailViewResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U039. 문의 등록
    [INSERT_QUESTION_SUCCESS]: (state, action) => ({
      ...state,
      insertQuestionResp: action.payload,
    }),
    [INSERT_QUESTION_FAILURE]: (state, action) => ({
      ...state,
      insertQuestionResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U040. 문의 수정
    [CHANGE_QUESTION_SUCCESS]: (state, action) => ({
      ...state,
      changeQuestionResp: action.payload,
    }),
    [CHANGE_QUESTION_FAILURE]: (state, action) => ({
      ...state,
      changeQuestionResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U041. 자료실 유저 다운로드
    [ARCHIVEFILE_DOWNLOAD_SUCCESS]: (state, action) => ({
      ...state,
      archivefileDownloadResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [ARCHIVEFILE_DOWNLOAD_FAILURE]: (state, action) => ({
      ...state,
      archivefileDownloadResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U042. 유저 문의 삭제
    [DELETE_INQRY_TOTAL_DATA_SUCCESS]: (state, action) => ({
      ...state,
      deleteInqryTotalDataResp: action.payload,
    }),
    [DELETE_INQRY_TOTAL_DATA_FAILURE]: (state, action) => ({
      ...state,
      deleteInqryTotalDataResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U044. 로그인후 공지사항 팝업 뷰 리스트
    [GET_ALL_NOTICE_POPUP_LOGIN_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getAllNoticePopupLoginListResp: action.payload,
    }),
    [GET_ALL_NOTICE_POPUP_LOGIN_LIST_FAILURE]: (state, action) => ({
      ...state,
      getAllNoticePopupLoginListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U047. 문의사항 게시판 엑셀 데이터 다운로드
    [EXCELL_CLIENT_INQUIRY_LIST_SUCCESS]: (state, action) => ({
      ...state,
      excellClientInquiryListResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [EXCELL_CLIENT_INQUIRY_LIST_FAILURE]: (state, action) => ({
      ...state,
      excellClientInquiryListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // U048. 공지사항 게시판 엑셀 데이터 다운로드
    [EXCELL_NOTICE_CLIENT_LIST_SUCCESS]: (state, action) => ({
      ...state,
      excellNoticeClientListResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [EXCELL_NOTICE_CLIENT_LIST_FAILURE]: (state, action) => ({
      ...state,
      excellNoticeClientListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //U067. 공지사항 게시판 파일 다운로드
    [NOTICE_FILE_DOWN_SUCCESS]: (state, action) => ({
      ...state,
      noticeFileDownResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [NOTICE_FILE_DOWN_FAILURE]: (state, action) => ({
      ...state,
      noticeFileDownResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    //U1114. 대시보드 공지 [전체/MY]
    [GET_NOTICE_DASHBOARD_SUCCESS]: (state, action) => ({
      ...state,
      getNoticeDashBoardResp: {
        data: action.payload,
        headers: action.headers,
      },
    }),
    [GET_NOTICE_DASHBOARD_FAILURE]: (state, action) => ({
      ...state,
      getNoticeDashBoardResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // FAQ 드롭다운 api
    [GET_FAQ_TYPE_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getFaqTypeListResp: {
        data: action.payload,
      },
    }),
    [GET_FAQ_TYPE_LIST_FAILURE]: (state, action) => ({
      ...state,
      getFaqTypeListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiServiceCntrResp;
